import React from 'react';
import InactiveCycleContractItem from '../InactiveCycleContractItem/InactiveCycleContractItem';
import { useLoadContractScreens } from '../../hooks/useLoadContractScreens';
import { TAB_NUMBER } from '../../../ContractScreensView/constants';
import SpinnerLoader from '../../../../components/SpinnerLoader/SpinnerLoader';
import { useInactiveCycles } from './hooks/useInactiveCycles';
import filterCyclesByContract from '../../utils/getCyclesByContract';

const InactiveCycleContractList: React.FC = () => {
  const { contracts, isLoading: isLoadingContractData } = useLoadContractScreens({ tabNumber: TAB_NUMBER.INACTIVE });
  const { cycles } = useInactiveCycles();

  if (!contracts.length && isLoadingContractData) {
    return (
      <div className="flex flex-row items-center justify-center">
        <SpinnerLoader />
      </div>
    );
  }

  if (!contracts.length && !isLoadingContractData) {
    return null;
  }

  return (
    <ul className='c-inactive-cycle-contract-list flex flex-col gap-y-1 pb-1'>
      {contracts.map((contract) => (
        <InactiveCycleContractItem
          key={contract.id}
          contractId={contract.id}
          contractName={contract.name}
          cycles={filterCyclesByContract(cycles, contract.id)}
        />
      ))}
    </ul>
  );
};

export default InactiveCycleContractList;